import NoRecommendations from './container';

export default NoRecommendations;



// WEBPACK FOOTER //
// ./src/routes/NoRecommendations/index.js